import { Player, startFromIndex } from '@ppwr/poker'

/**
 * @returns Array of players maintaining the correct sorting, but starting from "me" player, filtering "me" out.
 * If "me" is not present, returns original players array.
 */
export const sortPlayerStartingByMe = (players: Player[], me?: Player) => {
  if (!(me && players.includes(me))) return players

  const meIndex = players.findIndex((p) => p.id === me.id)
  if (!meIndex && meIndex !== 0) return players

  const sortedPlayerStartingByMe = startFromIndex(players, meIndex)

  return sortedPlayerStartingByMe.slice(1)
}

export const getPlayersForColumn = (players: Player[], left?: boolean) => {
  const leftAmount = Math.ceil(players.length / 2)

  if (left) return players.slice(0, leftAmount).reverse()

  return players.slice(leftAmount)
}

export const getPlayersColumns = <T>(items: T[]): { left: T[]; right: T[]; center: T[] } => {
  const total = items.length

  if (total === 9) {
    return {
      left: items.slice(0, 4).reverse(),
      center: [items[8]],
      right: items.slice(4, 8)
    }
  }

  const half = Math.ceil(total / 2)
  return {
    left: items.slice(0, half).reverse(),
    center: [],
    right: items.slice(half)
  }
}
